export const INTERNAL_USERS = [
  "niallconroy88@gmail.com",
  "chew_lewis@hotmail.com",
  "ewan.stott1@gmail.com",
];
